module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Router1-845138563161752dddd5af31331f3852.svg";